import i18next, { InitOptions } from 'i18next'
import LanguageDetector, {
  DetectorOptions,
} from 'i18next-browser-languagedetector'
import translationPL from '../translate/pl.json'
import translationEN from '../translate/en.json'
import HashQueryLocaleDetector from './HashQueryLocaleDetector'

export type translation = {
  t: (key: string) => string
}

const appLanguageDetector: LanguageDetector = new LanguageDetector()
const ourRouterQueryLocaleDetector = new HashQueryLocaleDetector()
appLanguageDetector.addDetector(ourRouterQueryLocaleDetector)
const i18detectorOptions: DetectorOptions = {
  order: ['routerquerystring'],
  lookupQuerystring: '__locale',
}
const i18nextOptions: InitOptions = {
  // -- info - nepouzivat 'lng' - nefunguje pak LanguageDetector
  // https://stackoverflow.com/questions/54514834/i18next-browser-languagedetector-path-not-working
  //lng: 'pl',
  fallbackLng: 'pl', // Set default language
  supportedLngs: ['pl', 'en'], // Setup defined languages
  resources: {
    pl: {
      translation: translationPL,
    },
    en: {
      translation: translationEN,
    },
  },
  detection: i18detectorOptions, // Setup LanguageDetector options
  returnObjects: true, // INFO toto by nam mohlo vyhovovat pro nacitani celych hierarchickych 'objektu' z translation na zaklade klice
  interpolation: {
    escapeValue: false, // cetl jsem, ze 'not needed for react'
  },

  react: {
    wait: true, // co to je?
  },
  debug: process.env.NODE_ENV === 'development', // zapnout debug mod [Y/N]
}

// https://github.com/i18next/i18next-browser-languageDetector/tree/v6.0.1
i18next.use(appLanguageDetector).init(i18nextOptions)

export default i18next
